<div class="container">
    <div class="title-1">Encuestas</div>
    <div class="row">
        <ul class="btn-group-survey">
            <li class="btn-survey" routerLink="encuestas" routerLinkActive="active">Encuestas</li>
            <li class="btn-survey" routerLink="org" routerLinkActive="active">Organización</li>
            <li class="btn-survey" routerLink="monitoreo" routerLinkActive="active">Monitoreo</li>
        </ul>
    </div>
</div>
<div class="container">
    <router-outlet></router-outlet>
</div>